module.exports = __webpack_public_path__ + "img/homeIncome2.74ee2e51.png";